import { axios } from 'shared/services/axios'

export function fetchGeoLocation() {
  return axios.get("/live_board/v1/geo_location")
    .then(response => response.data)
    .catch(() => null)
}